<div class="view-e-quote container" *ngIf="quotationDetails">
    <div class="d-flex justify-content-between align-items-center">
        <h2 class="improved-page-label">View Quotation</h2>
        <button type="button" class="btn btn-primary improved-add-btn" (click)="GoToDashboard()">Go to Dashboard</button>
    </div>

    <div class="row">
        <div class="col-12 quote-box mt-3">
            <div class="quote-info">
                <div class=" d-flex justify-content-between align-items-center">
                <p class="q-title mb-2">{{quotationDetails?.vProjectName}}</p>
                <div id="quotation-manufacturing-engineering-status" class="quotation-equote"> ENGINEERING </div>
            </div>
                <div class="d-flex ">
                    <div class="col-3">
                        <label class="label">Budget</label>
                        <p class="text-value" *ngIf="quotationDetails.iProductMinRange==null || quotationDetails.iProductMaxRange==null">Not Available</p>
                        <p class="text-value" *ngIf="quotationDetails.iProductMinRange !=null && quotationDetails.iProductMaxRange!=null">{{quotationDetails?.iCurrencyStatus==1 ? '₹' : '$'}} {{ quotationDetails.iProductMinRange | shortNumber }} - {{quotationDetails.iProductMaxRange | shortNumber }}</p>
                    </div>
                    <div class="col-4">
                        <label class="label">Uploaded Document</label>
                        <p class="text-value file-text" *ngIf="quotationDetails.vProductDocuments.length==0">No files uploaded</p>
                        <p class="text-value file-text" *ngIf="quotationDetails.vProductDocuments.length>0" role="button" [matMenuTriggerFor]="menuFiles">
                            {{quotationDetails.vProductDocuments.length}} files uploaded 
                        <img [src]="imagePath + 'info-blue.svg'" class="ms-2">
                        </p>
                        <mat-menu #menuFiles="matMenu" class="e-quote-file-name">
                            <!-- Loop over the files and display each as a clickable item -->
                            <a [href]="file.vFileUrl" target="_blank" mat-menu-item *ngFor="let file of quotationDetails.vProductDocuments" download>
                              {{ file.vFileName }}
                            </a>
                        </mat-menu>
                    </div>
                </div>
            </div>
            <div class="quote-details mb-2">
                <label class="heading-1 mb-3">View Quotation Details</label>
                <table class="e-quote-table">
                    <tr>
                        <th>Services</th>
                        <th>Total</th>
                    </tr>
                    <ng-container *ngFor="let service of quotationDetails?.quoteArray">
                        <tr *ngIf="service.subArray.length==0">
                            <td>{{service.vMasterServiceTitle}}</td>
                            <td *ngIf="service?.totalScore">{{service?.totalScore | currency : quotationDetails?.iCurrencyStatus==1 ? 'INR' : 'USD'}}</td>
                            <td *ngIf="!service?.totalScore">{{quotationDetails?.iCurrencyStatus==1 ? '₹' : '$'}}0</td>
                        </tr>
                        <tr *ngFor="let item of service.subArray">
                            <td>{{item.subServiceName}}</td>
                            <td *ngIf="item?.score">{{item?.score | currency }}</td>
                            <td *ngIf="!item?.score">{{quotationDetails?.iCurrencyStatus==1 ? '₹' : '$'}}0</td>
                        </tr>
                        <tr *ngFor="let item of service.inputValueArray">
                            <td *ngIf="item.score">{{item.name}} Cost ({{item.inputValue}} Units)</td>
                            <td *ngIf="item.score">{{item?.score | currency : quotationDetails?.iCurrencyStatus==1 ? 'INR' : 'USD'}}</td>
                        </tr>
                    </ng-container>
                    <tr>
                        <td>Total</td>
                        <td *ngIf="quotationDetails?.grandTotalScore">{{quotationDetails?.grandTotalScore | currency : quotationDetails?.iCurrencyStatus==1 ? 'INR' : 'USD'}}</td>
                        <td *ngIf="!quotationDetails?.grandTotalScore">{{quotationDetails?.iCurrencyStatus==1 ? '₹' : '$'}}0</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="col-4">

        </div>
    </div>
</div>
